import gql from 'graphql-tag';

export const ALLPREGUNTAS = gql`
    query{
        preguntas{
            _id
            subcategoria
            {
                _id
                nombre
            }
            enunciado
            peso
            orden
        }
    }
`;

export const PREGUNTA = gql`
    query ($id:String){
        pregunta(id:$id){
            _id
            subcategoria
            {
                _id
                nombre
            }
            enunciado
            peso
            orden
        }
    }
`;

export const NEWPREGUNTA = gql`
    mutation($pregunta:String){
        newPregunta(pregunta:$pregunta)
    }
`;

export const EDITPREGUNTA = gql`
    mutation($id:String, $pregunta:String){
        editPregunta(id:$id, pregunta:$pregunta)
    }
`;


